// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3OAwf","notes":"Notes_notes__2JzM-"};